import { render, staticRenderFns } from "./NavItemGroup.vue?vue&type=template&id=08c79490&scoped=true"
import script from "./NavItemGroup.vue?vue&type=script&lang=js"
export * from "./NavItemGroup.vue?vue&type=script&lang=js"
import style0 from "./NavItemGroup.vue?vue&type=style&index=0&id=08c79490&prod&lang=scss"
import style1 from "./NavItemGroup.vue?vue&type=style&index=1&id=08c79490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c79490",
  null
  
)

export default component.exports